<script>
    export let content
    export let context

    import Table from '../Table.svelte'

    const title = content.title;
    const tables = content.table_list;
    const anchor = content.anchor;

    const getTableContent = (jsonString) => {
        return JSON.parse(jsonString).blocks[0]
    };
</script>

<div class="section section-contact section-cent fp-auto-height-responsive anim bg-primary" data-section={anchor}>
    <section class="content clearfix fit">
        <div class="content-contact c-columns fit">
            <div class="row wrapper">
                <div class="columns small-12 medium-12 large-12">
                    <div class="col-wrapper anim">

                        <header class="title-desc">
                            <span class="anim-wrapper">
                                <h2 class="page-title">{title}</h2>
                            </span>
                        </header>

                        <div class="item-desc">
                            <div class="desc">
                                {#each tables as table}
                                    {#if getTableContent(table.table).type === 'table'}
                                        <Table description={table.caption} data={getTableContent(table.table).data.content} context={context}></Table>
                                    {/if}
                                {/each}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
</div>